
<button :type="type" class="c-btn" :disabled="disabled" :style=" outline ? `color: ${disabled ? 'gray' : color}; background: none; border: 1px solid ${disabled ? 'gray' : color};` : `background: ${disabled ? 'gray' : color}; color: white; ${disabled ? 'cursor: not-allowed; opacity: 0.7' : 'pointer opacity: 1'}`">
  <span v-if="!iconSrc" :class="labelClass" style="white-space: nowrap;">{{label}}</span>
  <img v-else class="c-icon" :src="iconSrc">
</button>
